<template>
  <v-layout row wrap pa-4 ma-4 class="profile-editar">
    <v-flex xs12>
      <h1>{{ $t('title.editProfile') }}</h1>

      <v-form v-model="valid" class="mt-4" @submit.prevent="saveProfile">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.name"
              :rules="nameRules"
              :label="$t('text.Name')"
              required
              class="input-name"
              autocomplete="nope"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field v-model="form.email" :rules="emailRules" :label="$t('text.Email')"></v-text-field>
          </v-flex>
        </v-layout>

        <v-btn
          color="primary right"
          type="submit"
          @click="saveProfile"
          dark
          large
          class="mt-4 mr-0 ml-0"
          :loading="sendingForm"
          :disabled="sendingForm"
        >{{$t('text.saveChanges')}}</v-btn>
      </v-form>
    </v-flex>

    <dialog-default
      :show="dialog.show"
      :title="dialog.title"
      :message="dialog.message"
      :ok="dialog.ok"
      v-on:close="dialogClose"
    ></dialog-default>
  </v-layout>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import DialogDefault from '@/components/dialog/Default';

export default {
  name: 'profile-editar',
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: 'Oops..',
        message:
          'Dados indisponíveis no momento. Tente novamente em alguns instantes.',
        ok: () => {}
      },

      form: {
        name: '',
        age: '',
        email: ''
      },

      isFacebook: this.$store.getters.profile.isFacebook,

      errors: [],
      valid: false,
      nameRules: [
        v => !!v || this.$t('errors.nameIsRequired'),
        v => v.length >= 3 || this.$t('errors.nameMustBeAtLeast3Characters')
      ],
      emailRules: [
        v => !!v || this.$t('errors.requiredEmail'),
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t('errors.invalidEmail')
      ]
    };
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    }
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    dialogClose: function() {
      this.dialog.show = false;
    },
    getProfile() {
      axios
        .get('/profiles/me/web')
        .then(response => {
          // console.info(response.data)

          this.form = response.data;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
          this.$store.commit('setProfile', response.data);
        })
        .catch(e => {
          // console.error(e)
          this.errors.push(e);
          this.dialog.show = true;
          bus.$emit('loading', false);
        });
    },
    saveProfile() {
      this.sendingForm = true;
      bus.$emit('loading', true);

      let body = {
        name: this.form.name,
        email: this.form.email
      };

      axios
        .put('/api/users', body)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          // console.warn(response)

          this.$store.commit('setProfile', body);

          this.sendingForm = false;
          bus.$emit('loading', false);

          this.dialog = {
            show: true,
            title: this.$t('profile.MyAccount'),
            message: this.$t('text.profileUpdateSuccessfully'),
            ok: () => {
              this.dialog.show = false;
            }
          };
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          // console.error(e)
          bus.$emit('loading', false);
          this.sendingForm = false;

          this.dialog = {
            show: true,
            title: 'Erro',
            message: this.$t(
              'errors.WeCouldNotUpdateYourProfilePleaseTryAgainLater'
            ),
            ok: () => {
              this.dialog.show = false;
            }
          };
        });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/_variables';

.profile-editar {
  @media (min-width: 960px) {
    .input-name {
      padding-right: 20px;
    }
  }

  .btn-vinculado-fb {
    margin: 10px 0 0 0;

    i {
      top: 3px;
    }

    span {
      padding: 10px;
      font-weight: 500;
    }
  }
}
</style>
